import { createSlice } from '@reduxjs/toolkit'
import { setCurrentFilterInfo, setInitialFilterInfo } from '../../../actions'

export const timeFilter = createSlice({
  name: 'timeFilter',
  initialState: [],
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setInitialFilterInfo, (state, action) => {
      const { payload = {} } = action.payload
      return (
        payload?.TIME?.map((slice, index) => ({
          ...slice,
          defaults: payload?.timeDefaults?.[index] || payload?.TIME?.[index],
        })) || { ...state }
      )
    })
    builder.addCase(setCurrentFilterInfo, (state, action) => {
      const { payload = {} } = action
      return payload?.timeFilter
    })
  },
})
